import http from '../../services/http';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('getTableStateVariant', (stateVariant = '') => ({
        data: null,
        packageIndex: 0,
        togglePackage(packageIndex) {
          this.packageIndex = packageIndex;
        },
        async init() {
          const apiUrl = `/ajax/incfile/packages/features?entity=LLC&state=${stateVariant}`;
          try {
            const response = await http.get(`${apiUrl}`, {
              headers: null,
            });
            if (response.status === 200 && response.data?.success) {
              this.data = response.data.data;
            }
          } catch (error) {
            console.error(
              'Error fetching package features:',
              error.response?.data || error.message,
            );
          }
        },
      }));
    });
  },
};
